
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Progress } from "@/components/ui/progress";
import { Badge } from "@/components/ui/badge";
import { useTranslation } from "react-i18next";
import { AIAnalysisResult } from "@/hooks/useAIAnalysis";

interface LevelAnalysisCardProps {
  levelAnalysis: AIAnalysisResult['levelAnalysis'];
}

const LevelAnalysisCard = ({ levelAnalysis }: LevelAnalysisCardProps) => {
  const { t } = useTranslation('ai-analysis');
  if (!levelAnalysis) return null;

  return (
    <Card>
      <CardHeader>
        <CardTitle>{t('levelAnalysis.title')}</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="grid md:grid-cols-3 gap-4">
          {Object.entries(levelAnalysis).map(([level, data]) => (
            <div key={level} className="p-4 border rounded-lg">
              <h4 className="font-semibold mb-2 capitalize">
                {t(`levelAnalysis.${level}`)}
              </h4>
              <div className="space-y-2">
                <div className="flex justify-between items-center">
                  <span className="text-sm">{t('levelAnalysis.averageScore')}</span>
                  <Badge variant="outline">{data.averageScore}/15</Badge>
                </div>
                <Progress value={(data.averageScore / 15) * 100} className="h-2" />
                <p className="text-sm text-gray-600">{data.performance}</p>
                {data.recommendations && (
                  <div className="mt-2">
                    <h5 className="text-xs font-medium text-gray-500 mb-1">Recommandations</h5>
                    <ul className="text-xs space-y-1">
                      {data.recommendations.map((rec, index) => (
                        <li key={index} className="text-gray-600">• {rec}</li>
                      ))}
                    </ul>
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  );
};

export default LevelAnalysisCard;
